'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _setImmediate2 = require('babel-runtime/core-js/set-immediate');

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactRedux = require('react-redux');

var _assets = require('redux/modules/assets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportAssetDialog = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    reporting: state.assets.reportingAsset,
    reported: state.assets.assetReported
  };
}, null, null, {
  withRef: true
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(ReportAssetDialog, _React$Component);

  function ReportAssetDialog() {
    (0, _classCallCheck3.default)(this, ReportAssetDialog);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportAssetDialog.__proto__ || (0, _getPrototypeOf2.default)(ReportAssetDialog)).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(ReportAssetDialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.dispatch((0, _assets.resetReportAsset)());

      setTimeout(function () {
        _this2.refs.textarea.focus();
      }, 100);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.reported && nextProps.reported) {
        setTimeout(this.forceClose.bind(this), 3000);
      }
    }
  }, {
    key: 'forceClose',
    value: function forceClose(reason) {
      if (this.props.reporting) return false;

      this.props.onCloseNo(reason);
    }
  }, {
    key: 'handleReportAssetClick',
    value: function handleReportAssetClick() {
      var _this3 = this;

      var _props = this.props,
          dispatch = _props.dispatch,
          assetId = _props.asset;

      var message = this.refs.textarea.value;

      if (!message.length) {
        this.setState({
          error: false
        });
        (0, _setImmediate3.default)(function () {
          return _this3.setState({ error: true });
        });

        return;
      }

      dispatch((0, _assets.reportAsset)({ assetId: assetId, message: message }));
    }
  }, {
    key: 'handleCancelClick',
    value: function handleCancelClick() {
      this.props.onCloseNo();
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var styles = require('./ReportAssetDialog.scss');
      var _props2 = this.props,
          reporting = _props2.reporting,
          reported = _props2.reported;


      var classes = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.ReportAssetDialog, true), (0, _defineProperty3.default)(_classnames, styles['ReportAssetDialog--error'], this.state.error), _classnames));

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
          'div',
          { className: styles['ReportAssetDialog__inner'] },
          reporting ? _react2.default.createElement(_components.LoadingIndicator, { className: styles['ReportAssetDialog__loading-indicator'] }) : reported ? _react2.default.createElement(
            'div',
            { className: styles['ReportAssetDialog__success-message'] },
            'Thank you! We have your feedback regarding this asset. We\'ll take a look shortly!'
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: styles['ReportAssetDialog__question'] },
              'How do you like to report this asset?'
            ),
            _react2.default.createElement('textarea', { ref: 'textarea', rows: '4', className: styles['ReportAssetDialog__textarea'] }),
            _react2.default.createElement(
              'div',
              { className: styles['ReportAssetDialog__buttons'] },
              _react2.default.createElement(_components.Button, { className: styles['ReportAssetDialog__button'], label: 'Cancel', onClick: this.handleCancelClick.bind(this) }),
              _react2.default.createElement(_components.Button, { primary: true, alternative: true, className: styles['ReportAssetDialog__button'], label: 'Report', onClick: this.handleReportAssetClick.bind(this) })
            )
          )
        )
      );
    }
  }]);
  return ReportAssetDialog;
}(_react2.default.Component)) || _class);
exports.default = ReportAssetDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportAssetDialog/ReportAssetDialog.jsx
// module id = 2656
// module chunks = 0